interface TabSegmentProps {
  tabIndex: number;
  segments: string[];
  onTabChange: (index: number) => void;
  className?: string;
}

const TabSegment = ({ tabIndex, segments, onTabChange, className = '' }: TabSegmentProps) => {
  return (
    <div
      className={`w-full h-full flex items-stretch rounded-[12px] bg-surface-lv2 p-[4px] ${className}`}
    >
      {segments.map((segment, index) => (
        <button
          key={`tab-segment-${segment}`}
          type="button"
          onClick={() => onTabChange(index)}
          className={`flex-1 h-full rounded-[8px] text-[15px] font-semibold text-center leading-none transition-colors ${
            index === tabIndex
              ? 'bg-pure-white text-main-light-1 dark:bg-[rgba(255,255,255,0.14)] dark:text-main-dark-3'
              : 'bg-transparent text-main-light-3 dark:text-[#656070]'
          }`}
        >
          {segment}
        </button>
      ))}
    </div>
  );
};

export { TabSegment };
